import React from "react";
import DatePickerInput from "./DatePickerInput";
import { Stack } from "@mui/material";

export interface DateRangePickerInterface {
  iconColor?: string;
  startDate?: string;
  endDate?: string;
  onStartDateChange: (param: any) => void;
  onEndDateChange: (param: any) => void;
}

const DateRangePicker = ({
  iconColor,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}: DateRangePickerInterface) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {iconColor ? (
        <i className={`fal fa-calendar font-${iconColor} icon-md`} />
      ) : null}
      <DatePickerInput
        value={startDate}
        onChange={onStartDateChange}
        placeholder="Start Date"
      />
      <DatePickerInput
        value={endDate}
        onChange={onEndDateChange}
        placeholder="End Date"
      />
    </Stack>
  );
};
export default DateRangePicker;
